/**
 * @generated SignedSource<<c6d14b80de8b73ad68e7b1d9f7fc7093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemProducts_StoreProduct$data = ReadonlyArray<{
  readonly name: string | null;
  readonly " $fragmentType": "TodoListItemProducts_StoreProduct";
}>;
export type TodoListItemProducts_StoreProduct$key = ReadonlyArray<{
  readonly " $data"?: TodoListItemProducts_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemProducts_StoreProduct">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoListItemProducts_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "ee2a4555dd2e72e8be90ace1c6554ed3";

export default node;
